<template>
    <section>
        <div class="wrapper wrapper-content" style="padding-top: 0;">
            <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                <div class="sk-bounce1"></div>
                <div class="sk-bounce2"></div>
                <div class="sk-bounce3"></div>
            </div>
            <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <h2>Selected <span v-if="selectedTable.tableType === 1">Slot</span><span v-else>Table</span>: <a href="javascript:void(0)" @click="selectNewTable"><b>{{this.selectedTable && this.selectedTable.name}}</b> </a></h2>
                            </div>
                            <div class="flex-end">
                              <h2 class="m-r-md"><button type="button" class="btn btn-warning " @click="holdCurrentOrder()">Hold Order</button></h2>
                              <h2 class="m-r-md"><button type="button" class="btn btn-danger " @click="cancelOrder()">Cancel Order</button></h2>
                              <h2 class="m-r-md" v-if="this.selectedTable.tableType !== 1">Waiter: <a href="javascript:void(0)" @click="updateWaiter"><b>{{(this.selectedTableOrder && this.selectedTableOrder.waiter === null) ? 'No Waiter' : this.selectedTableOrder.waiter.name}}</b></a> </h2>
                            </div>
                        </div>
            <div class="row"  v-if="menu.length > 0"  id="main-content">
                <div class="col-md-12">
                    <div class="ibox-content grey" style="padding: 0;">
                        <PosReceipt ref="posReceipt" id="pos" style="display:none" v-if="selectedTableOrder.orderItemsById.length>0"
                             v-bind:selectedTable="selectedTable"
                              v-bind:selectedTableOrder="selectedTableOrder"
                              v-bind:orderCreatedtime="$parent.orderHistory.created"></PosReceipt>
                        <div class="row">
                            <div class="col-md-12" style="display: flex;justify-content: space-between;">
                                <div style="flex-basis: 63%;">
                                    <ul v-if="!Object.keys(clickedCategory).length" class="category-group">
                                        <li  :class="{'widget style1 category-group-item lazur-bg': true, 'yellow-bg' : Object.keys(clickedCategory).length && clickedCategory.id === category.id}" v-for="(category, index) in menu" v-if="!category.deleted"  v-bind:key="index+'cat_sidebar'" @click="fetchMenuItemOfCategory(category)">
                                            <h5 class="media-heading">{{ category.name }}</h5>
                                            <p>{{ category.menuItemsById.filter(menuItem=>menuItem.deleted === false).length }} Items</p>
                                        </li>
                                    </ul>
                                    <section v-if="Object.keys(clickedCategory).length">
                                        <a @click="clickedCategory = {}"><h2><i class="fa fa-arrow-left"></i> Back</h2></a>
                                        <ul class="category-group">
                                            <li class="menue-group-item" v-for="(menuItem,indexMenuItem) in clickedCategory.menuItemsById" v-if="!menuItem.deleted" v-bind:key="indexMenuItem+'item_main_menu'" @click="showAdOns(menuItem, menuItem.menuItemTypesById[0], clickedCategory.name, true)">
                                                <div class="image-container">
                                                    <img :src='(menuItem.menuItemImagesByMenuItemId.length > 0) ? getOptimizedImageUrl(menuItem.menuItemImagesByMenuItemId[0].imageUrl) : "img/placeholder.png" ' alt="profile">
                                                </div>
                                                <div style="font-weight: bold;">
                                                    <p> {{ menuItem.name }}</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </section>
                                </div>
                                <div class=" cart_panel" id="print" style="margin-top: 7px; flex-basis: 35%">
                                    <div class="panel panel-primary" style="border-color:white; border-radius: 0;">
                                        <div class="panel-heading">
                                            <b>Cart</b>
<!--                                            <a title="Hold Order" style="color: #FFF;" class="myTip pull-right"  @click="holdCurrentOrder()"><b><i class="fa fa-clock-o"></i> Hold Order</b></a>-->
                                        </div>
                                        <div class="panel-body" >
                                            <div class="table-responsive" style="height: 50vh; overflow-y: auto;">
                                                <table class="table table-hover cart_table hideTableBottom">
                                                    <thead>
                                                        <tr style="white-space: nowrap;" >
                                                            <th colspan="4">Item Name</th>
                                                            <th class="text-right" colspan="1">Total Price</th>
                                                            <th class="text-right"><i class="fa fa-bolt"></i></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(orderItem, orderItemIndex) in this.selectedTableOrder.orderItemsById" >
                                                            <tr v-bind:key="orderItemIndex">
                                                                <td class="increaseLineHeight" colspan="4" >
                                                                    <a style="white-space: pre-wrap" v-bind:title="(orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name + ', ' +orderItem.menuItemTypesByMenuItemTypeId.serving + '(' + orderItem.menuItemTypesByMenuItemTypeId.price + 'Rs. )')"><b class="text-success">{{orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name}} - {{orderItem.menuItemTypesByMenuItemTypeId.serving}} </b></a>
                                                                    <br/>
                                                                    <div class="input-group spinner m-t-sm" style="max-width: 60px">
                                                                        <div class="input-group-btn-vertical">

                                                                          <div class="minusplusnumber">
                                                                            <div class="mpbtn minus" @click="updateOrderItemQuantity(orderItemIndex, 'dec')">
                                                                              <b>-</b>
                                                                            </div>
                                                                            <div id="field_container">
                                                                              <b><input type="number" v-bind:value="orderItem.quantity" disabled /></b>
                                                                            </div>
                                                                            <div class="mpbtn plus" v-on:click="updateOrderItemQuantity(orderItemIndex, 'inc')">
                                                                              <b>+</b>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td class="text-right increaseLineHeight">{{orderItem.totalPrice | formatNumber}} Rs.</td>
                                                                <td class="text-right increaseLineHeight"><button type="button" v-on:click="removeItemFromCart(orderItemIndex, orderItem.menuItemTypesByMenuItemTypeId)" class="btn btn-xs btn-danger"><i class="fa fa-times"></i></button></td>
                                                            </tr>
                                                            <template v-for="(itemAddOn, itemAddOnIndex) in orderItem.orderItemAddOnsById">
                                                                <tr v-bind:key="orderItemIndex+'_'+itemAddOnIndex">
                                                                    <!-- <td colspan="2">
                                                                        <div class="input-group spinner pull-right" style="max-width: 60px">
                                                                            <input type="text" readonly="readonly" class="form-control" v-bind:value="itemAddOn.quantity">
                                                                            <div class="input-group-btn-vertical">
                                                                                <button class="btn btn-primary" v-on:click="updateAdOnQuantity(orderItemIndex,itemAddOnIndex,'inc')" type="button"><i class="fa fa-caret-up"></i></button>
                                                                                <button class="btn btn-primary" v-on:click="updateAdOnQuantity(orderItemIndex,itemAddOnIndex,'dec')" type="button"><i class="fa fa-caret-down"></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </td> -->
                                                                    <td colspan="3"></td>
                                                                    <td class="text-center increaseLineHeight">{{itemAddOn.addOnItemsByAddOnItemId.name}}</td>
                                                                    <td class="text-right increaseLineHeight" colspan="1">{{(itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price) | formatNumber}} Rs.</td>
                                                                </tr>
                                                            </template>
                                                            <!-- <tr v-bind:key="orderItemIndex+'_'" style="border-bottom: solid 1px #CCCCCC">
                                                                <td colspan="5" class="instruction_text">
                                                                    <p class="text-danger" v-bind:title="orderItem.instructions">{{(orderItem.instructions === null) ? '' : orderItem.instructions}}</p>
                                                                </td>
                                                            </tr> -->
                                                            <tr>
                                                                <td colspan="6"><hr style="margin: 0;"/></td>
                                                            </tr>
                                                        </template>
                                                        <tr v-if="this.selectedTableOrder.orderItemsById.length === 0">
                                                            <td colspan="6">No Item In Cart!</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <!-- Order Stats Table -->
                                            <div class="table-responsive m-t-lg">
                                              <div style="text-align:center;">
                                                <h4>Payment Method</h4>
                                                <button value="cash" @click="ChangePayment(1, 'cash-btn')" id="cash-btn" class="btn btn-primary btn-large-dim navy-bg" :class="selectedTableOrder.paymentMethod.id===1 ? 'yellow-bg': ''" style="width:70px;height:70px; margin:10px" type="button"><i class="fa fa-money"></i></button>
                                                <button value="card" @click="ChangePayment(2, 'card-btn')" id="card-btn" class="btn btn-primary btn-large-dim navy-bg" :class="selectedTableOrder.paymentMethod.id===2 ? 'yellow-bg': ''" style="width:70px;height:70px; margin:10px" type="button"><i class="fa fa-credit-card"></i></button>
                                              </div>
                                                <table class="table table-hover cart_table hideTableBottom m-t-lg" v-if="selectedTableOrder.paymentMethod.id!==0">
                                                        <tbody>
                                                            <template class="static" v-if="this.selectedTableOrder.orderItemsById.length !== 0">
<!--                                                            <tr>-->
<!--                                                                <td colspan="4" class="text-right">Subtotal:</td>-->
<!--                                                                <td class="text-right"><b>{{this.selectedTableOrder.totalPrice | formatNumber}} Rs.</b></td>-->
<!--                                                            </tr>-->
<!--                                                            <tr>-->
<!--                                                                <td colspan="4" class="text-right">Subtotal With AdOn's:</td>-->
<!--                                                                <td class="text-right"><b>{{this.selectedTableOrder.totalPriceWithAddon | formatNumber}} Rs.</b></td>-->
<!--                                                            </tr>-->
                                                            <tr>
                                                              <td colspan="4" class="text-right">Sub Total</td>
                                                              <td class="text-right text-success" style="font-size: 15px"><b>{{this.selectedTableOrder.totalPriceWithAddon | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                              <tr>
                                                                <td class="text-right" colspan="4">Tax Amount <b v-if="selectedTableOrder.paymentMethod.id===1" class="text-info">({{selectedTableOrder.branchesByBranchId.tax}}%)</b><b v-if="selectedTableOrder.paymentMethod.id===2" class="text-info">({{selectedTableOrder.branchesByBranchId.cardTax}}%)</b></td>
                                                                <td class="text-right" v-if="selectedTableOrder!==''">{{Math.round(this.selectedTableOrder.totalPriceAfterTax - this.selectedTableOrder.totalPriceWithAddon )}} Rs.</td>
                                                              </tr>
                                                            <tr>
                                                              <td colspan="4" class="text-right">Billed Price</td>
                                                              <td class="text-right text-success" style="font-size: 15px"><b>{{this.selectedTableOrder.billedPrice | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                        </template>
                                                        </tbody>
                                                    </table>
                                            </div>
                                            <!-- <hr/> -->
                                            <ul class="category-group">
                                              <li class="cart-btn-item" v-if="this.selectedTableOrder.orderItemsById.length !== 0"> <button type="button" class="btn btn-success" @click="print()" :disabled="this.selectedTableOrder.paymentMethod.id===0">Print Bill</button></li>
                                              <li class="cart-btn-item" style="flex-basis: 45%;" v-if="this.selectedTableOrder.orderItemsById.length !== 0"> <button type="button" :disabled="this.selectedTableOrder.paymentMethod.id===0" class="btn btn-primary btn-block" @click="finalizeOrder()">Finish Order</button></li>
                                            </ul>
                                            <!-- <div class="row" v-if="this.selectedTableOrder.orderItemsById.length !== 0">
                                                <div class="col-md-4 text-center">
                                                    <button type="button" class="btn btn-info" @click="sendToKitchen()" :disabled="selectedTableOrder.orderHistoriesById.length>1" :id="this.selectedTable.id">Send To Kitchen</button>
                                                </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Old Html-->
                        <!-- <div class="row">
                            <div class="col-md-2 category_panel">
                                <div class="theiaStickySidebar">
                                    <div class="panel panel-primary ">
                                        <div class="panel-heading">
                                            <b>Menu Categories</b>
                                        </div>
                                        <div class="panel-body" id="menu category_nav_bar">
                                             <ul class="nav">
                                                <li><a href="#most_popular">Most Popular</a></li>
                                                <li v-for="(category, index) in menu" v-if="!category.deleted"  v-bind:key="index+'cat_sidebar'">
                                                    <a v-bind:href="'#' + category.name.replace(/[ /]/g, '')" v-bind:title="category.name" v-bind:class="(category.name.length > 17) ? 'myTip link' : 'link'">{{(category.name.length > 17) ? category.name.substring(0,17)+'...' : category.name}}</a>
                                                </li>
                                            </ul> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="panel panel-primary" >
                                    <div class="panel-heading">
                                        <b>Items</b>
                                    </div>
                                    <div class="panel-body">
                                        <multiselect v-model="multiselectSelectedItem"
                                                     :options="this.$parent.itemOptions"
                                                     :custom-label="customLabel" :track-by="this.$parent.itemOptions.serving"
                                                     @input="findAdOnCategoriesOfItemType(multiselectSelectedItem)"
                                                     >
                                        </multiselect>
                                        <section>
                                            <h3 id="most_popular" class="text-success"><b>Most Popular</b></h3>
                                            <ul class="list-group" >
                                                <template v-for="(mCategory) in menu" >
                                                    <li class="list-group-item list-group-item-info" v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-if="menuItem.mostPopular && !menuItem.deleted" v-bind:key="indexMenuItem+'_popular_'+menuItem.name">
                                                        <div class="row">
                                                            <div class="col-md-7">
                                                                <b>{{menuItem.name}}</b>
                                                                <p>{{menuItem.description}}</p>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <table class="menu_table hideTableBottom table table-hover">
                                                                    <tbody>
                                                                    <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-bind:key="indexMenuItemType+'type_popular'">
                                                                        <td>{{menuItemType.serving}}</td>
                                                                        <td class="text-center">{{menuItemType.price}} Rs.</td>
                                                                        <td class="text-right">
                                                                            <button v-on:click="showAdOns(menuItem, menuItemType, mCategory.name)" class="btn btn-sm btn-primary">Select</button>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </template>
                                            </ul>
                                        </section>
                                        <section v-for="(mCategory, index) in menu" v-if="!mCategory.deleted" v-bind:key="index+'cat_main_menu'">
                                            <h3 v-bind:id="mCategory.name.replace(/[ /]/g, '')" class="text-success"><b>{{mCategory.name}}</b></h3>
                                            <ul class="list-group">
                                                <li class="list-group-item list-group-item-info" v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-if="!menuItem.deleted" v-bind:key="indexMenuItem+'item_main_menu'">
                                                    <div class="row">
                                                        <div class="col-md-7">
                                                            <b>{{menuItem.name}}</b>
                                                            <p>{{menuItem.description}}</p>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <table class="menu_table hideTableBottom table table-hover">
                                                                <tbody>
                                                                <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-if="!menuItemType.deleted" v-bind:key="indexMenuItemType+'type_main_menu'">
                                                                    <td>{{menuItemType.serving}}</td>
                                                                    <td class="text-center">{{menuItemType.price}} Rs.</td>
                                                                    <td class="text-right">
                                                                            <button v-on:click="showAdOns(menuItem, menuItemType, mCategory.name)" class="btn btn-sm btn-primary">Select</button>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </section>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5 cart_panel" id="print">
                                
                            </div> 

                        </div> -->
                    </div>
                </div>
            </div>
        </div>
         <!-- Ad - On Modal -->
        <div class="modal" id="adOnsPopUp" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="servingQuantiy=1"><span aria-hidden="true">&times;</span></button>
                        <h3 class="modal-title" id="adOnsPopUpLabel">Details Of <b>{{this.selectedMenuItem.name}}</b>
                            <!-- <span style="float:right; margin-right:10px;"><b>Total Price: {{this.adonModalTotal}}</b></span> -->
                        </h3>
                    </div>
                    <div class="modal-body row">
                        <template>
                            <h3>Select the Serving</h3>
                            <ul class="category-group">
                                <li v-for="(menuItemType, indexMenuItemType) in this.selectedMenuItem.menuItemTypesById" :class="{'widget style1 serving-group-item lazur-bg': true, 'yellow-bg' :  selectedMenuItemType.id === menuItemType.id}"
                                v-if="!menuItemType.deleted" v-bind:key="indexMenuItemType+'type_main_menu'" v-on:click="showAdOns(selectedMenuItem, menuItemType, selectedMenuCategory)">
                                    <h5 class="media-heading">{{ menuItemType.serving }}</h5>
                                </li>
                            </ul>
                          <div class="row">
                            <div class="form-group col-md-4">
                              <label class="font-14">Quantity</label><br>
                              <div class="minusplusnumber">
                                <div class="mpbtn minus" v-on:click="updateServingQuantity(servingQuantiy-1)">
                                  <b>-</b>
                                </div>
                                <div id="field_container">
                                  <b><input type="number" v-model="servingQuantiy" disabled style="width: 150px" /></b>
                                </div>
                                <div class="mpbtn plus" v-on:click="updateServingQuantity(servingQuantiy+1)">
                                  <b>+</b>
                                </div>
                              </div>

<!--                              <PlusMinusField :min="1" :value="servingQuantiy" @increment="updateServingQuantity(val)" @decrement="updateServingQuantity(val)" />-->
                            </div>
                          </div>

                        </template>
                        <template>
                          <span v-if="selectedAdOnCategory && selectedAdOnCategory[0]">
                            <hr><h3 v-if="selectedAdOnCategory && selectedAdOnCategory[0]">Select the Add-ons of Serving</h3><br>
                          </span>
                            <section class="col-md-6" v-for="adOnCat in selectedMenuItemTypeAdOns" v-if="!adOnCat.deleted" v-bind:key="'itemTypeAdon_cat_modal_' + adOnCat.id + Math.random()">
                                <b>{{adOnCat.addOnCategory.name.split('-->')[0] + ' (' + adOnCat.addOnCategory.allowedItems + ')'}}</b><b class="text-danger small" v-if="adOnCat.addOnCategory.required"> (required)</b>
                                <div class="checkbox" v-for="adOnName in adOnCat.addOnCategory.addOnItemsById" v-bind:key="'itemTypeAdon_cat_item_modal_'+adOnName.id + Math.random()">
                                    <label>
                                        <input type="checkbox" v-bind:checked="checkSelectedAdOns(adOnName.id)" v-on:click="checkAdOnLimitAndAddAdOn(adOnCat.addOnCategory.allowedItems, adOnName.id, adOnCat.addOnCategory.id, $event,adOnName, adOnCat)"/> {{adOnName.name + ' - ' + adOnName.price + ' Rs.'}}
                                    </label>
                                </div>
                            </section>
                            <section class="col-md-6" v-for="adOnCat in selectedAdOnCategory" v-if="!adOnCat.deleted" v-bind:key="'adon_cat_modal_' + adOnCat.id + Math.random()">
                                <b class="font-16">{{adOnCat.addOnCategory.name.split('-->')[0] + ' (' + adOnCat.addOnCategory.allowedItems + ')'}}</b><b class="text-danger small" v-if="adOnCat.addOnCategory.required"> (required)</b>
                                <div class="checkbox font-14" v-for="adOnName in adOnCat.addOnCategory.addOnItemsById" v-bind:key="'adon_cat_item_modal_'+adOnName.id + Math.random()">
                                    <label>
                                        <input type="checkbox" v-bind:checked="checkSelectedAdOns(adOnName.id)" v-on:click="checkAdOnLimitAndAddAdOn(adOnCat.addOnCategory.allowedItems, adOnName.id, adOnCat.addOnCategory.id, $event, adOnName, adOnCat)"/> {{adOnName.name + ' - ' + adOnName.price + ' Rs.'}}
                                    </label>
                                </div>
                            </section>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal" @click="servingQuantiy=1">Close</button>
                        <button v-if="!editOrderItem" type="button" v-on:click="addOrderItem()" class="btn btn-primary">Add To Cart</button>
                        <button v-if="editOrderItem" type="button" v-on:click="editOrderItemInCart(null, null, true)" class="btn btn-primary">Update Cart</button>
                    </div>
                </div>
            </div>
        </div>
        <FinalizeOrder v-bind:order="selectedTableOrder" ref="finalizeOrder"/>
        <div class="modal" data-backdrop="static" data-keyboard="false" id="update_waiter" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="reset()"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="update_waiter_modalLabel">Assign Waiter to Table: {{this.$parent.selectedTable.name}}</h4>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <ul class="table-group">
                      <li v-for="(waiter, index) in this.$parent.branchWaiters.filter(waiter=>!waiter.deleted)" :key="index" @click="waiterClicked(waiter, index)" class="widget style1 navy-bg waiter table-group-item" :id="'new_waiter_' +waiter.id" style="cursor:pointer">
                        <h2 class="media-heading">{{waiter.name}}</h2>
                      </li>
                    </ul>

                  </div>
                  <!-- </div> -->
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-success pull-right" @click="selectNewWaiter">select</button>
                  </div>
                </div>
                <br/>
              </div>
            </div>
          </div>
        </div>
        <div class="modal" data-backdrop="static" data-keyboard="false" id="update_table" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="reset()"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title" id="assign_table_modalLabel">Selected Table: {{previousTable && previousTable.name}}</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <ul class="table-group">
                    <li v-for="(table, index) in branchTables" :key="index" @click="tableClicked(table, index)" class="widget style1 navy-bg table table-group-item" :id="'new_table_' +table.id" style="cursor:pointer">
                      <h2 class="media-heading">{{table.name}}</h2>
                    </li>
                  </ul>
                  <h4 v-if="branchTables.length===0">No table available</h4>
                </div>
                <!-- </div> -->
              </div>
              <div class="row">
                <div class="col-md-12">
                  <button class="btn btn-success pull-right" @click="updateTable">select</button>
                </div>
              </div>
              <br/>
            </div>
          </div>
        </div>
      </div>
        <div class="modal" data-backdrop="static" data-keyboard="false" id="add_void_item" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetVoidItem"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title" id="assign_table_modalLabel">Add Reason To Void Item</h4>
            </div>
              <form @submit.prevent="addVoidItem()">
                <div class="modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Reason</label>
                    <select class="form-control" v-model="voidItem.message" required="required">
                      <option disabled selected value="">Select reason to void item</option>
                      <option v-for="(reason, index) in Reasons()" :value="reason" :key="index">{{reason}}</option>
                    </select>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-12">
                  <button type="submit" class="btn btn-success pull-right">Confirm</button>
                </div>
              </div>
              <br/>
            </div>
              </form>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
    import ImgixClient from '@imgix/js-core';
    import Multiselect from 'vue-multiselect';
    // import posReceipt from './receipt';
    import PosReceipt from './Receipt';
    import FinalizeOrder from '@/components/pos/FinalizeOrderPopup'
    import {addVoidItem} from "@/api/voidItems";
    import {Reasons} from "@/Constants/VoidItemCancellationReasons";
    import PlusMinusField from "@/components/PlusMinusField/PlusMinusField.vue";
    export default {
        name: "BranchMenu",
        props:["menu","selectedTableOrder","selectedBranch", "selectedTable", "branchTables"],
        data: function () {
            return {
                newUpdatedWaiter: {},
                clickedCategory: {},
                flex:"",
                restaurants: [],
                branches: [],
                selectedRestaurant: "",
                isHideSpinner: "hide",
                selectedAdOnCategory: [],
                noAdOns: false,
                adOnSelection: {},
                requiredAdOns:[],
                selectedMenuItemTypeAdOns: [],
                selectedMenuItem:"",
                addOns:[],
                selectedMenuItemType:"",
                selectedMenuCategory:"",
                multiselectSelectedItem:"",
                selectedOrderItemIndexForEdit: -1,
                editOrderItem:false,
                allowRemove:false,
                notRemoveItemFromCart:false,
                editOrderItemIndex:"",
                checkedAddOns:[],
                selectedAdOns:[],
                adonModalTotal:0,
                inputValue: 0,
                servingQuantiy: 1,
                orderItemAddon:{
                        id:0,
                        quantity:1,
                        addOnItemsByAddOnItemId:{
                            id:0,
                            name:"",
                            price:"",
                            addOnCategoriesByAddOnCategoryId:{
                                id:0,
                                name:"",
                                allowedItems:0,
                                required:false
                            }
                        }
                    },
                newTable: null,
                previousTable: null,
                voidItem: {
                  "id": 0,
                  "menuItemTypesByMenuItemTypeId": {},
                  "tableName": '',
                  "waiter": "",
                  "message": ""
                }
            }
        },
        components:{PlusMinusField, PosReceipt,Multiselect, FinalizeOrder},
        watch: {
            //watch to check for required addons
            selectedMenuItemTypeAdOns: function() {
                for(let key in this.selectedMenuItemTypeAdOns){
                    if ( this.selectedMenuItemTypeAdOns.hasOwnProperty(key) ) {
                        (this.selectedMenuItemTypeAdOns[key].addOnCategory.required) && (this.requiredAdOns.push(this.selectedMenuItemTypeAdOns[key].addOnCategory.id.toString()));
                    }
                }
            },
            selectedAdOnCategory: function() {
                for(let key in this.selectedAdOnCategory){
                    if ( this.selectedAdOnCategory.hasOwnProperty(key) ) {
                        (this.selectedAdOnCategory[key].addOnCategory.required) && (this.requiredAdOns.push(this.selectedAdOnCategory[key].addOnCategory.id.toString()));
                    }
                }
            },
        },
        computed: {
            adOns: function () {
                if (this.selectedAdOnCategory.name) { return this.selectedAdOnCategory.menuItemAdOns }
                else if (this.selectedAdOnCategory.serving) { return this.selectedAdOnCategory.menuItemTypeAdOns }
            },
        },
        mounted() {
          console.log('branchTables ', this.branchTables)
          // this.newTable = this.$parent.selectedTable
          if (!this.selectedTable.status) {
            this.selectedTable.status=1
          }
          this.previousTable = this.selectedTable
          this.selectedTableOrder.paymentMethod.id = 0
        },
        updated: function () {
            $('.i-checks').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green',
            });

        $('#adOnsPopUp').on('hidden.bs.modal', function (e) { //reseting values if model hide
            this.selectedAdOns=[];
            this.selectedAdOnCategory=[];
            this.selectedMenuItemTypeAdOns=[];
            this.adOnSelection=[];
            this.addOns= $.extend(true,[],[]);
            this.editOrderItem=false;
            // this.selectedwaiter="";
        });
        },
        methods: {
          updateServingQuantity(val) {
            if (val > 0 && val <= 50) {
              this.servingQuantiy = val
            }
          },
          Reasons() {
            return Reasons
          },
          reset() {
            $(".table").removeClass('yellow-bg')
            $(".waiter").removeClass('yellow-bg')
          },
            getOptimizedImageUrl (originalURL) {
                const imageURLObject = new URL(originalURL);
                const finalURLForImgix = '/menu/' + imageURLObject.pathname.split('%2F')[1] + '/' + imageURLObject.pathname.split('%2F')[2] + '/' + imageURLObject.pathname.split('%2F')[3].replaceAll('+', ' ');
                const client = new ImgixClient({
                    domain: 'bayked.imgix.net'
                });
                return client.buildURL(finalURLForImgix, {h: 90, w: 90, fit: 'crop'});
            },
            fetchMenuItemOfCategory (selectedCategory) {
                if(this.clickedCategory.id === selectedCategory.id){
                    this.clickedCategory = {}
                    return;
                }
                this.clickedCategory = selectedCategory;
            },
            holdCurrentOrder () {
              this.selectedTable.status=0
              console.log(this.selectedTable);
              this.$emit('orderType', this.selectedTable.tableType)

                // Object.assign(this.selectedTable, {
                //     id:0,
                //     status:"",
                //     name:""
                // });
            },
            cancelOrder() {
              this.voidItem.tableId = this.selectedTable.id
              this.voidItem.message=""
              $("#add_void_item").modal("show");
            },
            customLabel: function (opt){ //label to show in menu search bar
                return `${opt.categoryName} — ${opt.itemName} - ${opt.serving}`;
            },
            findAdOnCategoriesOfItemType: function (menuItem) { //method to show addons if item selected from menu search bar
                    this.showAdOns(menuItem.menuItem, menuItem.menuItemType, menuItem.categoryName);
                    this.multiselectSelectedItem=null;
            },
            showAdOns: function(menuItem, menuItemType, categoryName, deselect) { //method to show addons of selected item if exist
            if (menuItemType === this.selectedMenuItemType) {
              this.selectedMenuItemType = ""
              this.selectedAdOnCategory = ""
              this.selectedMenuItemTypeAdOns = ""
              return
            }
            this.addOns= $.extend(true,[],[]);
            this.editOrderItem=false;
            this.selectedAdOns=[];
            this.adOnSelection=[];
            this.selectedMenuItem= menuItem;
            if (!deselect) {
              this.selectedMenuItemType = menuItemType;
              this.selectedMenuCategory= categoryName;
              this.selectedMenuItemTypeId = menuItemType.id;
              this.selectedAdOnCategory = $.extend(true, {}, menuItem.menuItemAdOns); //menu item level addons
              this.selectedMenuItemTypeAdOns = $.extend(true, {}, menuItemType.menuItemTypeAdOns); //menu item-type addon
            } else {
              this.selectedMenuItemType = ''
              this.selectedMenuCategory = ''
              this.selectedMenuItemTypeId = ''
              this.selectedAdOnCategory = []
              this.selectedMenuItemTypeAdOns = []
            }
            this.requiredAdOns = [];

            this.calculateFinanceForAdonModal();
            if(!$("#adOnsPopUp").is(':visible')) {
              $("#adOnsPopUp").modal("show");
            }
          },
            checkSelectedAdOns: function (selectedAdOnId) { //method to check selected addons in addons popup
                for (let a in this.adOnSelection){
                    for (let aid of this.adOnSelection[a]){
                        if (aid === selectedAdOnId){
                            return true;
                        }
                    }
                }
                return false;
            },
            checkAdOnLimitAndAddAdOn: function(limit, adOnItemId, adOnCategoryId, e, adOnName, adOnCat) { //check adon limit and populate addon array of item
               if(this.addOns.length===0){
                   this.addOns= $.extend(true,[],[]);
               }
                let existingAdOns = this.adOnSelection[adOnCategoryId];
                this.resetOrderItemAdon;
                var adOnObjct = $.extend(true,{},this.orderItemAddon);  //creating a copy of adon object and push in addon array
                adOnObjct.addOnItemsByAddOnItemId.id=adOnName.id;
                adOnObjct.addOnItemsByAddOnItemId.name=adOnName.name;
                adOnObjct.addOnItemsByAddOnItemId.price=adOnName.price;
                adOnObjct.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id= adOnCat.addOnCategory.id;
                adOnObjct.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.name= adOnCat.addOnCategory.name;
                adOnObjct.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.allowedItems= adOnCat.addOnCategory.allowedItems;
                adOnObjct.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.required= adOnCat.addOnCategory.required;

                if(e.target.checked){
                    if(existingAdOns === undefined){
                        this.adOnSelection[adOnCategoryId] = [];
                        this.adOnSelection[adOnCategoryId].push(adOnItemId);
                        this.addOns.push(adOnObjct);
                        // this.selectedAdOns.push(adOnObjct);
                        
                    }else if(existingAdOns.length === limit){
                        swal("ERROR!", "You can not add more ad ons!", "error");
                        e.target.checked = false;
                    }else{
                        this.adOnSelection[adOnCategoryId].push(adOnItemId);
                        this.addOns.push(adOnObjct);
                        // this.selectedAdOns.push(adOnObjct);
                    }
                }else{
                    for(let i in this.addOns){
                        if(this.addOns[i].addOnItemsByAddOnItemId.id=== adOnItemId){
                            this.addOns.splice(i, 1);
                        }
                    }
                    let index = existingAdOns.indexOf(adOnItemId);
                    if (index > -1) {
                        existingAdOns.splice(index, 1);
                    }
                }
                this.calculateFinanceForAdonModal();
            },
            calculateFinanceForAdonModal: function (){
                this.adonModalTotal=this.selectedMenuItemType.price;
                if(this.addOns.length>0){
                    for(var adonPrice of this.addOns){
                        this.adonModalTotal= this.adonModalTotal+adonPrice.addOnItemsByAddOnItemId.price;
                    }
                }
                

            },
            addOrderItem: function () { //add order item in cart
              if (!this.selectedMenuItemType) {
                swal("Warning!","Make sure at least one option of is selected!", "warning")
                return
              }
              if (!this.servingQuantiy || this.servingQuantiy == 0) {
                swal("Warning!","Enter valid quantity!", "warning")
                return
              }
                let adOns=[]; //here check if all required addons are checked
                let required = [];
                for (var key in this.adOnSelection) {
                    if (this.adOnSelection.hasOwnProperty(key) && this.adOnSelection[key].length > 0) {
                        required.push(key.toString());
                        adOns.push(this.adOnSelection[key]);
                    }
                }
                this.selectedAdOns= $.extend(true,[],this.addOns); //copy selected/edited addons in selectedadons
              if (this.requiredAdOns.every((i) => required.includes(i))){ //check for requied addons
                var objct = $.extend(true,{},this.$parent.orderItem);
                objct.quantity = objct.quantity * this.servingQuantiy;
                objct.totalPrice= this.selectedMenuItemType.price * objct.quantity;
                objct.menuItemTypesByMenuItemTypeId.id=this.selectedMenuItemTypeId;
                objct.menuItemTypesByMenuItemTypeId.price= this.selectedMenuItemType.price;
                objct.menuItemTypesByMenuItemTypeId.serving=this.selectedMenuItemType.serving;
                this.selectedAdOns.forEach((addOn) => {
                  addOn.quantity *= this.servingQuantiy;
                });
                objct.orderItemAddOnsById = this.selectedAdOns;
                objct.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.id= this.selectedMenuItem.id;
                objct.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name= this.selectedMenuItem.name;
                objct.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.menuCategoriesByMenuCategoryId.name= this.selectedMenuCategory;

                this.selectedTableOrder.orderItemsById.push(objct); //push the addon object in array of order item
                let price= this.selectedTableOrder.totalPrice;
                this.selectedTableOrder.totalPrice= this.selectedTableOrder.totalPrice +  this.selectedMenuItemType.price;
                this.calculateFinance();
                
                this.selectedMenuItemTypeAdOns=[];
                this.selectedAdOnCategory=[];
                this.adOnSelection=[];
                this.selectedAdOns=[];
                $("#adOnsPopUp").modal("hide");
                this.calculateFinance();
                this.servingQuantiy = 1
                this.selectedMenuItemType = ''
            }else { swal("Warning!","Make Sure at least One option of each Required Ad'On(s) is Selected", "warning") }
            },

            removeItemFromCart: function(orderItemIndex, serving){ //remove item from cart -->1) remove from selected order then write this order to localstorage
              this.resetVoidItem()
              this.voidItem.menuItemTypesByMenuItemTypeId = serving
              this.voidItem.orderItemIndex = orderItemIndex
              this.voidItem.branchId = this.selectedBranch.id
              this.voidItem.tableName = this.newTable ? this.newTable.name : this.previousTable ? this.previousTable.name : 'N/A'
              this.voidItem.waiter = this.selectedTableOrder.waiter && this.selectedTableOrder.waiter.name ? this.selectedTableOrder.waiter.name : 'N/A'
              $("#add_void_item").modal("show");
            },

          resetVoidItem() {
            this.voidItem = {
              "id": 0,
              "menuItemTypesByMenuItemTypeId": {},
              "tableName": "",
              "waiter": "",
              "message": ""
            }
            this.allowRemove = false
          },

          async addVoidItem() {
            try {
              let orderItemIndex = this.voidItem.orderItemIndex
              delete this.voidItem.orderItemIndex

              if (this.voidItem.tableId) {
                this.voidItem.branchId = this.selectedBranch.id
                this.voidItem.tableName = this.newTable ? this.newTable.name : this.previousTable ? this.previousTable.name : 'N/A'
                this.voidItem.waiter = this.selectedTableOrder.waiter && this.selectedTableOrder.waiter.name ? this.selectedTableOrder.waiter.name : 'N/A'
              }

              await addVoidItem(this.voidItem);

              if (this.voidItem.tableId) {
                delete this.voidItem.tableId
                $("#add_void_item").modal("hide");
                this.$parent.fetchBranchTables()
                return;
              }
              if (!this.notRemoveItemFromCart) {
                this.selectedTableOrder.totalPrice = this.selectedTableOrder.totalPrice - this.selectedTableOrder.orderItemsById[orderItemIndex].menuItemTypesByMenuItemTypeId.price * this.selectedTableOrder.orderItemsById[orderItemIndex].quantity;
                this.selectedTableOrder.orderItemsById.splice(orderItemIndex, 1);
              } else {
                this.selectedTableOrder.orderItemsById[orderItemIndex].quantity -= 1;
                this.selectedTableOrder.orderItemsById[orderItemIndex].totalPrice = this.selectedTableOrder.orderItemsById[orderItemIndex].menuItemTypesByMenuItemTypeId.price * this.selectedTableOrder.orderItemsById[orderItemIndex].quantity;
                this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById.map((e, index)=>this.updateAdOnQuantity(orderItemIndex, index, 'dec'))
              }
              await this.calculateFinance();
              this.allowRemove = true
            } catch (e) {
              this.showErrorMessage(e)
              this.allowRemove = false
            }
            this.notRemoveItemFromCart = false
            $("#add_void_item").modal("hide");
          },

            updateOrderItemQuantity: function(orderItemIndex,operation){ //update qunatity of order item
                switch (operation) {
                    case 'inc':
                        if(this.selectedTableOrder.orderItemsById[orderItemIndex].quantity < 50){
                            this.selectedTableOrder.orderItemsById[orderItemIndex].quantity += 1;
                            this.selectedTableOrder.orderItemsById[orderItemIndex].totalPrice= this.selectedTableOrder.orderItemsById[orderItemIndex].menuItemTypesByMenuItemTypeId.price * this.selectedTableOrder.orderItemsById[orderItemIndex].quantity;
                            this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById.map((e, index)=>this.updateAdOnQuantity(orderItemIndex, index, 'inc'))
                        }
                        break;
                    case 'dec':
                        if(this.selectedTableOrder.orderItemsById[orderItemIndex].quantity > 1){
                          let serving = this.selectedTableOrder.orderItemsById[orderItemIndex].menuItemTypesByMenuItemTypeId
                          this.notRemoveItemFromCart = true
                          this.removeItemFromCart(orderItemIndex, serving)
                          if (this.allowRemove) {
                            this.selectedTableOrder.orderItemsById[orderItemIndex].quantity -= 1;
                            this.selectedTableOrder.orderItemsById[orderItemIndex].totalPrice = this.selectedTableOrder.orderItemsById[orderItemIndex].menuItemTypesByMenuItemTypeId.price * this.selectedTableOrder.orderItemsById[orderItemIndex].quantity;
                          }
                        }
                        break;
                }
              this.calculateFinance();
            },
            updateAdOnQuantity: function(orderItemIndex,itemAddOnIndex, operation){  //update qunatity of order item addons
                switch (operation) {
                    case 'inc':
                        if(this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById[itemAddOnIndex].quantity < 50){
                            this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById[itemAddOnIndex].quantity += 1;
                        }
                        break;
                    case 'dec':
                        if(this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById[itemAddOnIndex].quantity > 1){
                            this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById[itemAddOnIndex].quantity -= 1;
                        }
                        break;
                }
                this.calculateFinance();
            },
            showAdOnsOfCart: function(menuItem, menuItemType, categoryName) { //show addons of cart
                this.editOrderItem=true;
                var menu_item = $.extend(true, {}, menuItem);
                var menu_item_type= $.extend(true, {}, menuItemType);
                this.selectedMenuItem= menu_item;
                this.selectedMenuItemType= menu_item_type;
                this.selectedMenuCategory= categoryName;
                this.selectedMenuItemTypeId = menu_item_type.id;
                
                if(menu_item.menuItemAdOns.length === 0 && menu_item_type.menuItemTypeAdOns.length === 0){
                    this.requiredAdOns = []
                    this.addOrderItem();
                }else{
                    this.selectedAdOnCategory = $.extend(true, {}, menu_item.menuItemAdOns);
                    this.selectedMenuItemTypeAdOns = $.extend(true, {}, menu_item_type.menuItemTypeAdOns);
                    this.calculateFinanceForAdonModal();
                    $("#adOnsPopUp").modal("show");
                }
            },
            editOrderItemInCart: function (orderItem, orderItemIndex, onlyUpdate) { //calls whan pencil of orderitem in cart clicked
                if(!onlyUpdate){
                    this.selectedAdOnCategory=[];
                    this.selectedMenuItemTypeAdOns=[];
                    this.adOnSelection=[];
                    this.editOrderItemIndex= orderItemIndex;
                    this.selectedAdOns= orderItem.orderItemAddOnsById;
                    for(let orderItemAdon of orderItem.orderItemAddOnsById){
                        if(this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id] === undefined){
                            this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id] = [];
                        }
                        this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id].push(orderItemAdon.addOnItemsByAddOnItemId.id);
                    }
                    for(let menuCategory of this.menu){ //finding menu item of order item to get all addons to show in popup
                        for(let menuItem of menuCategory.menuItemsById){
                            for(let menuItemType of menuItem.menuItemTypesById){
                                if(menuItem.id === orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.id && menuItemType.id ===orderItem.menuItemTypesByMenuItemTypeId.id){
                                    console.log(menuItemType);
                                    this.addOns= $.extend(true,[],this.selectedTableOrder.orderItemsById[this.editOrderItemIndex].orderItemAddOnsById);
                                    this.showAdOnsOfCart(menuItem, menuItemType, menuCategory.name);
                                }
                            }
                        }
                    }
                }else{
                    console.log("Updating Cart..."); //when update cart clicked
                    console.log(this.selectedMenuItemType);
                    this.selectedTableOrder.orderItemsById[this.editOrderItemIndex].orderItemAddOnsById=$.extend(true,[],this.addOns);
                    let adOns=[];
                    let required = [];
                    for (var key in this.adOnSelection) { //prepare to check for all required addons
                        if(this.adOnSelection.hasOwnProperty(key) && this.adOnSelection[key].length > 0){
                            required.push(key.toString());
                            adOns.push(this.adOnSelection[key]);
                        }
                    }                   
                    if (this.requiredAdOns.every((i) => required.includes(i))){
                        this.calculateFinance();
                        // this.editOrderItem = false;
                        this.editOrderItem=false;
                        $("#adOnsPopUp").modal("hide");
                    }else{ swal("Warning!","Make Sure at least One option of each Required Ad'On(s) is Selected", "warning") }
            }
            },
            calculateFinance: async function(){ //calculate finance of selected order object
                let totalprice= 0;
                let addonprice=0;
                let temp=0;
                for(let order of this.selectedTableOrder.orderItemsById){
                    temp= order.menuItemTypesByMenuItemTypeId.price * order.quantity;
                    totalprice= totalprice + temp;
                    for(let addon of order.orderItemAddOnsById){
                        addonprice=addonprice+ (addon.addOnItemsByAddOnItemId.price* addon.quantity);
                    }
                }
                this.selectedTableOrder.totalPrice= totalprice;
                this.selectedTableOrder.totalPriceWithAddon= addonprice + totalprice;
                if(this.selectedTableOrder.couponsByCouponId!==null){
                    if(this.selectedTableOrder.couponsByCouponId.inPercentage){
                        this.selectedTableOrder.discount= Math.round((this.selectedTableOrder.totalPriceWithAddon /100)*this.selectedTableOrder.couponsByCouponId.discount);
                    }else{
                        this.selectedTableOrder.discount= this.selectedTableOrder.couponsByCouponId.discount;
                    } 
                }
                if (isNaN(this.selectedTableOrder.discount)) {
                  this.selectedTableOrder.discount = 0
                }
                if(this.selectedTableOrder.paymentMethod.id===1){
                    this.selectedTableOrder.totalPriceAfterTax= Math.round(this.selectedTableOrder.totalPriceWithAddon + (this.selectedTableOrder.totalPriceWithAddon/100)*this.selectedBranch.tax);
                    this.selectedTableOrder.billedPrice= Math.round(this.selectedTableOrder.totalPriceAfterTax - this.selectedTableOrder.discount);
                }
                else if(this.selectedTableOrder.paymentMethod.id===2){
                    this.selectedTableOrder.totalPriceAfterTax= this.selectedTableOrder.totalPriceWithAddon + (this.selectedTableOrder.totalPriceWithAddon/100)*this.selectedBranch.cardTax;
                    // this.selectedTableOrder.billedPrice= this.selectedTableOrder.totalPriceAfterTax; //need to think whether to calculate billed price here or not
                    this.selectedTableOrder.billedPrice= Math.round(this.selectedTableOrder.totalPriceAfterTax - this.selectedTableOrder.discount);
               }
                await this.$parent.updateOrderObject(this.selectedTableOrder, this.selectedTable.id);
                
            },
            resetOrderItemAdon(){ //reset order model
                this.orderItemAddon={
                        id:0,
                        quantity:1,
                        addOnItemsByAddOnItemId:{
                            id:0,
                            name:"",
                            price:"",
                            addOnCategoriesByAddOnCategoryId:{
                                id:0,
                                name:"",
                                allowedItems:0,
                                required:false
                            }
                        }
                    }
            },
            sendToKitchen: async function(){  //add status in order object and disable send to kitchen button
                console.log("Sent to kitchen");
                var statusObject = $.extend(true, {}, this.$parent.orderHistory);
                const date= new Date;
                statusObject.created= date.toISOString();
                statusObject.statusesByStatusId.id=21;
                statusObject.statusesByStatusId.name="SENT TO KITCHEN";
                // this.selectedTableOrder.orderHistoriesById.push(statusObject);
                await this.$parent.updateOrderObject(this.selectedTableOrder, this.selectedTable.id);
            },
            print: function(){
                const WinPrint =window.open('', '', 'left=0,top=0,width=400,height=500px,toolbar=0,scrollbars=0,status=0');
                WinPrint.document.write(document.getElementById('pos').innerHTML) ;
                WinPrint.document.close();
                WinPrint.focus();
                WinPrint.print();
                window.e = WinPrint;
                console.log('printing');
                setTimeout(()=>{
                    WinPrint.close();
                },500)
                console.log('closing')
            },
            finalizeOrder: function(){ //popup finalize order modal
                this.$refs.finalizeOrder.load(this.selectedTableOrder, this.selectedTable);
            },
            submitOrderObject: function(cashtaken) { //submit the selected order object to engine to save this
            // if(this.selectedTableOrder.paymentMethod.id===2){
            //     this.inputValue= this.selectedTableOrder.billedPrice;
            // }
            // else{
            //     this.inputValue='';
            // }
            // const { value: cashTaken} = Swal.fire({
            //     title: "Cash Taken",
            //     text: 'Total Cash: ' + this.selectedTableOrder.billedPrice,
            //     input: 'text',
            //     inputLabel: 'Cash Taken',
            //     inputValue: this.inputValue,
            //     showCancelButton: true,
            //     confirmButtonText: 'Punch',
            //     showLoaderOnConfirm: true,
                // preConfirm: (cashtaken) => {
                    this.$parent.selectedTableOrder.cashTaken=cashtaken
                    this.$parent.selectedTableOrder.cashGiven= cashtaken-this.$parent.selectedTableOrder.billedPrice;
                    let orderCreated= this.selectedTableOrder.orderHistoriesById[0];
                    this.selectedTableOrder.orderHistoriesById=[];
                    this.$http.post(this.$store.state.mainAppURL + 'pos/save_pos_order/', this.selectedTableOrder).then(resp=>{
                        this.$parent.selectedTableOrder.id= resp.data.id;
                        let param1= new URLSearchParams();
                        param1.append("order_id", resp.data.id);
                        param1.append("status_id", 20);
                        param1.append("created", orderCreated.created);
                        this.$http.post(this.$store.state.mainAppURL + 'pos/add_status_of_pos_order/', param1).then(resp=>{
                            console.log("Saved");
                            this.print();
                            this.$parent.selectedTable.status= 0;
                            let param= new URLSearchParams();
                            param.append("table_id", this.$parent.selectedTable.id);
                            param.append("table_status", this.$parent.selectedTable.status);
                            this.$http.post(this.$store.state.mainAppURL + "pos/update_table_status", param).then(resp=>{
                                console.log("Table Updated");
                                localStorage.removeItem(this.selectedBranch.id + "_" +this.selectedTable.id);
                                $("#"+ this.selectedTable.id).removeClass("red-bg");
                                // $("#finalize_order").modal('hide');
                                swal("SUCCESS!", "Order has been saved successfully", "success");
                                this.$parent.selectedTable.status=""
                                this.$parent.fetchBranchTables()

                            })
                          $("#order_view_model").modal('hide');
                        });
                    })


                // },
                // allowOutsideClick: () => !Swal.isLoading(),
                // inputValidator: (value) => {
                //     if (!value) {
                //     return 'Enter The Amount Taken From Customer'
                //     }
                //     else if(value< this.selectedTableOrder.billedPrice){
                //         return 'Collected Amount is less then Total Amount'
                //     }
                // }
            // })

            },
            discardOrder: function () { //remove order from localstorage also update status of table in database
                console.log("Discard");
                Swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to cancel this order! This will delete all order data from cache.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1ab394',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Cancel it!'
                }).then((result) => {
                    if (result.value) {
                        this.isHideSpinner = "";
                        this.$parent.selectedTable.status= 0;
                        let param = new URLSearchParams();
                        param.append("table_id", this.$parent.selectedTable.id);
                        param.append("table_status", this.$parent.selectedTable.status);
                        this.$http.post(this.$store.state.mainAppURL + "pos/update_table_status", param).then(resp => {
                            if(resp.data){
                                localStorage.removeItem(this.selectedBranch.id + "_" +this.selectedTable.id);
                                $("#"+ this.selectedTable.id).removeClass("red-bg");
                                swal("SUCCESS!", "Order has been successfully canceled", "success");
                            }else{
                                swal("Error!", "Invalid Placement", "error");
                            }
                            this.isHideSpinner = "hide";
                        }).catch(ex => {
                            this.isHideSpinner = "hide";
                            swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                        });
                    }
                });
            },
          updateWaiter() {
            console.log('selectedTableOrder ', this.selectedTableOrder)
            console.log('this.$parent.orderObject ', this.$parent.orderObject)

            this.newUpdatedWaiter = this.selectedTableOrder.waiter
            $(".waiter").removeClass('yellow-bg')
            this.newUpdatedWaiter && $('#new_waiter_'+ this.newUpdatedWaiter.id).addClass('yellow-bg');
            $("#update_waiter").modal("show");
          },
          waiterClicked: function(waiter) { //selected waiter
            this.newUpdatedWaiter = waiter;
            $(".waiter").removeClass('yellow-bg')
            $('#new_waiter_'+ waiter.id).addClass('yellow-bg');
          },
          tableClicked: function(table){ //selected table
            this.newTable = table
            console.log('previous ', this.previousTable.name)
            console.log('new ', this.newTable.name)
            $(".table").removeClass('yellow-bg')
            $('#new_table_'+ table.id).addClass('yellow-bg');
          },
          async selectNewWaiter () {
            if (this.newUpdatedWaiter) {
              this.$parent.orderObject.waiter = this.newUpdatedWaiter
              this.selectedTableOrder.waiter = this.newUpdatedWaiter
              await this.$parent.updateOrderObject(this.selectedTableOrder, this.$parent.selectedTable.id);
            }
            $('#update_waiter').modal("hide");
            this.reset()
          },
          selectNewTable () {
            if (this.selectedTable.tableType === 1) return
            $("#update_table").modal("show");
            console.log('tables', this.$parent.branchTables)
          },

          async updateTable() {
            (this.branchTables.length > 0 && this.newTable)  && await this.updateTableStatus(this.previousTable.id, this.newTable.id)
            $('#update_table').modal("hide");
            this.reset()
          },

          updateTableStatus(oldId, newId) {
            let param= new URLSearchParams();
            param.append("table_id_with_order", oldId)
            param.append("new_table_id", newId)
            param.append("branch_id", this.$parent.selectedBranch.id)
            this.$http.post(this.$store.state.mainAppURL + "pos/update_table_order", param) //update status to reserved in db
                .then(async resp=> {
                  console.log("Table Updated.");
                  this.$parent.branchTables = resp.data
                  this.newTable.status = 1
                  Object.assign(this.$parent.selectedTable, this.newTable);
                  // this.$parent.selectedTable = this.newTable;

                  console.log('this.$parent.selectedTable ', this.$parent.selectedTable)
                })
          },

          ChangePayment: function(paymentMethod, id){
            if (this.selectedTableOrder.paymentMethod.id === paymentMethod) {
              this.selectedTableOrder.paymentMethod.id = 0
            } else {
              this.selectedTableOrder.paymentMethod.id = paymentMethod
            }
            this.selectedTableOrder.discount= (this.$parent.selectedTableOrder.totalPriceWithAddon /100)*this.discount;
            if (this.selectedTableOrder.paymentMethod.id !== paymentMethod) {
              $('#' + id).css('background-color', '#1ab394');
            } else {
              $('#' + id).css('background-color', '');
            }
            this.calculateFinance();
          },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.c2d_cont_1{
    height: 205px !important;
    overflow: auto;
}
.blocking_overlay{
    position: absolute;
    display: block;
    width: 96%;
    height: 100%;
    top: 2px;
    left: 12px;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 2;
    cursor: not-allowed;
    opacity: 0.75;
}
.blocking_overlay i{
    font-size: 125px;
    line-height: 1.85;
    color: #f9204b;
}
.hideTableBottom > tbody > tr > td{
    border-top: 0 !important;
}
.cart_table > tbody > tr > td{
    /* padding: 5px;
    white-space: nowrap; */
}
.increaseLineHeight{
    /* line-height: 2; */
}

.spinner {
    width: 100px;
}
.spinner input {
    text-align: right;
}
.input-group-btn-vertical {
    position: relative;
    white-space: nowrap;
    width: 1%;
    vertical-align: middle;
    display: table-cell;
}
.input-group-btn-vertical > .btn {
    display: block;
    float: none;
    width: 100%;
    max-width: 100%;
    padding: 8px;
    margin-left: -1px;
    position: relative;
    border-radius: 0;
}
.input-group-btn-vertical > .btn:first-child {
    border-top-right-radius: 4px;
}
.input-group-btn-vertical > .btn:last-child {
    margin-top: -2px;
    border-bottom-right-radius: 4px;
}
.input-group-btn-vertical i{
    position: absolute;
    top: 0;
    left: 4px;
}
#complaint_alert{
    width: 27%;
    position: fixed;
    bottom: 0;
    right: 42px;
}
.list-group-item{
    padding: 5px 15px !important;
}
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9{
    /* padding-right: 4px !important;
    padding-left: 4px !important; */
}
    .instruction_text{
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .category-group{
        display: flex;
        flex-wrap: wrap;
        padding-left: 0;
    }
    .category-group-item {
        margin-right: 10px;
        padding: 10px;
        flex: auto;
        /* text-align: center; */
        list-style: none;
        width: 100px;
        max-width: 100px;
        max-height: 100px;
        height: 100px;
        cursor: pointer;
        box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
        -webkit-box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
        -moz-box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
    }
    .cart-btn-item{
        flex: auto;
        list-style: none;
    }
    .menue-group-item{
        margin-right: 10px;
        margin-bottom: 15px;
        padding-top: 5px;
        background-color: #e7eaec;
        flex: auto;
        text-align: center;
        font-size: 12px;
        list-style: none;
        max-width: 100px;
        width: 100px;
        cursor: pointer;
        border-radius: 10px;
        /* height: 220px; */
        box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
        -webkit-box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
        -moz-box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
    }
    .serving-group-item{
        margin: 10px;
        list-style: none;
        padding: 5px;
        width: 80px;
        max-width: 80px;
        max-height: 80px;
        height: 80px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
        -webkit-box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
        -moz-box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.34);
    }
    .menue-group-item > .image-container {
        margin-bottom: 10px;
    }
    .menue-group-item > .image-container > img {
        width: 90px; 
        height: 90px;
        border-radius: 99em;
    }

.fix-pos {
  position: fixed;
  bottom: 0;
  right: 4rem;
  z-index: 2;
  background-color: #fff;
  padding: 1rem;
  width: 35%;
}
.scroll-45 {
  overflow-y: auto;
  overflow-x: hidden;
  height: 70%;
}
.min-height-50 {
  height: 50rem;
}
.grey {
  background-color: #f3f3f4 !important;
}
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.flex-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>
